<template>
    <div class="tabbar-container">
        <div class="scrollbar-container">
            <div class="bh bc user-title fz_34 milieu-tag" :class="`${milieuTag}-tag`">
                个人中心
                <van-button @click="go('UserSite')" class="mask-ico-site btn btn-mask-ico m0"></van-button>
            </div>
            <div class="bh bstart user-info">
                <div
                    v-on:click="changeImg"
                    class="userImg radius bg-cover"
                    :class="imgCls"
                    :style="{backgroundImage: 'url(' + $store.getters.userInfo.headImageUri + ')'}"
                ></div>
                <div>
                    <div class="changeType">
                        <van-button
                            v-show="$store.state.isGoAms"
                            class="changeBtn fz_24 c_white"
                            @click="nativeBack"
                        >切换商城模式</van-button>
                    </div>
                    <div class="fz_36">{{telephone}}</div>
                    <van-button @click="go('UserIntegral')" class="btn btn-text">
                        <div class="bh bstart fz_28 c_333">
                            <div class="btn-ico-el ico-integral bg-contain"></div>车主币：
                            <span class="text">{{$store.getters.unusedPoints}}</span>
                        </div>
                    </van-button>
                </div>
            </div>
            <div class="line"></div>
            <div class="owner bh bc">
                <div class="img bg-contain bh bend" @click="go('UserOwnerActivation')">
                    <div
                        class="activation bg-contain"
                        :class="isAnimation?'img-animation':''"
                        @click.stop="onActivationClick"
                    ></div>
                </div>
            </div>
            <div class="line"></div>
            <div class="list">
                <van-button @click="go('UserOrder')" class="btn border-bottom btn-text">
                    <div class="bh bstart">
                        <div class="btn-ico-el ico-order bg-100"></div>
                        <span class="fz_30">我的订单</span>
                        <div class="b1 tr fz_28">
                            <span class v-if="orderCount">{{orderCount}}条&ensp;</span>
                        </div>
                    </div>
                </van-button>
                <van-button @click="go('UserCouponsGas')" class="btn border-bottom btn-text">
                    <div class="bh bstart">
                        <div class="btn-ico-el ico-gasCoupons bg-100"></div>
                        <span class="fz_30">加油卡券</span>
                    </div>
                </van-button>
                <van-button @click="go('UserCouponsHome')" class="btn border-bottom btn-text">
                    <div class="bh bstart">
                        <div class="btn-ico-el ico-coupons bg-100"></div>
                        <span class="fz_30">车主卡券</span>
                    </div>
                </van-button>
                <van-button class="btn border-bottom btn-text" @click="onAddressClick">
                    <div class="bh bstart">
                        <div class="btn-ico-el ico-address bg-100"></div>
                        <span class="fz_30">收货地址</span>
                    </div>
                </van-button>
                <van-button
                    class="btn btn-text"
                    :class="isApp?'border-bottom':''"
                    @click="onTelClick"
                >
                    <div class="bh bstart">
                        <div class="btn-ico-el ico-service bg-100"></div>
                        <span class="fz_30">服务热线</span>
                    </div>
                </van-button>
                <van-button @click="onLoginOutClick" class="btn btn-text" v-show="isApp">
                    <div class="bh bstart">
                        <div class="btn-ico-el ico-loginout bg-100"></div>
                        <span class="fz_30">退出</span>
                    </div>
                </van-button>
            </div>
        </div>
    </div>
</template>
<script>
import { upImg } from "@/api/user";
import util from "@/utils/index";
import { appSwitchAMSystem, appLoginout } from "@/utils/native";
import { cuImage, callTel } from "@/utils/bridge";
export default {
    name: "UserHome",
    data() {
        return {
            imgCls: null,
            // 微信原生功能配置
            wx: {},
            isAnimation: false
        };
    },
    computed: {
        userInfo() {
            return this.$store.getters.userInfo;
        },
        telephone() {
            const userInfo = this.userInfo;
            if (userInfo && userInfo.telephone) {
                return util.plusXing(userInfo.telephone, 3, 8);
            }
            return "";
        },
        orderCount() {
            return this.$store.state.cart.orderCount;
        },
        headImageUri() {
            const userInfo = this.userInfo;
            return userInfo ? userInfo.headImageUri : "";
        },
        isApp() {
            return this.$store.state.isApp;
        },
        milieuTag() {
            return this.$store.state.milieuTag;
        }
    },
    created() {
        // 获取用户订单数量
        this.$store.dispatch("cart/orderCount");
        // 获取用户信息
        this.$store.dispatch("userInfo");
    },
    methods: {
        onTelClick() {
            callTel(this.$store.state.tell);
        },
        nativeBack() {
            // 切换到商城
            appSwitchAMSystem();
        },
        onAddressClick() {
            this.$router.push({
                name: "UserAddressHome",
                params: { isBuy: false }
            });
        },
        // 更换头像
        changeImg: function() {
            cuImage(this.wx).then(res => {
                // this.dialog.alert({ title: "changeImg", message: res });
                upImg({
                    uri: res
                }).then(data => {
                    this.$store.state.userInfo.headImageUri = res;
                });
            });
        },
        onLoginOutClick: function() {
            appLoginout();
        },
        // 动画效果
        onActivationClick() {
            const me = this;
            me.isAnimation = true;
            setTimeout(() => {
                me.isAnimation = false;
                me.go("UserOwnerActivation");
            }, 250);
        }
    }
};
</script>
<style scoped lang="scss">
@include ico-list(
    "~@/assets/imges/ico/user/",
    "coupons",
    "integral",
    "order",
    "service",
    "address",
    "gasCoupons"
);
[data-theme="app"] {
    @include ico-list(
        "~@/assets/imges/app/ico/user/",
        "address",
        "coupons",
        "order",
        "service"
    );
}
.tabbar-container {
    background-color: #eeeeee;
}
@keyframes scaleDraw {
    /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/
    0% {
        transform: scale(1); /*开始为原始大小*/
    }
    50% {
        transform: scale(1.1);
    }
}
.img-animation {
    -webkit-animation: scaleDraw 0.25s ease-in-out infinite;
}
.scrollbar-container {
    .user-title {
        position: relative;
        padding: 30px 0 28px 0;
        background-color: #fff;
        color: #333;
        .mask-ico-site {
            position: absolute;
            top: 38px;
            right: 40px;
            width: 36px;
            height: 36px;
            -webkit-mask-image: url("~@/assets/imges/user/site.png");
        }
    }
    .user-info {
        position: relative;
        background-color: #fff;
        padding: 0 0 60px 40px;
        .userImg {
            width: 128px;
            height: 128px;
            margin-right: 30px;
        }
        .changeType {
            position: absolute;
            top: 60px;
            right: 30px;
            .changeBtn {
                line-height: 58px;
                padding: 0;
                height: 58px;
                width: 180px;
                border-radius: 29px;
                background-color: #c30d23;
            }
        }

        .ico-integral {
            width: 34px;
            height: 34px;
            margin-right: 12px;
        }
        .text {
            color: #ff9a2b;
        }
    }
    .owner {
        background-color: #fff;
        padding: 20px 0;
        .img {
            width: 700px;
            height: 160px;
            background-image: url("~@/assets/imges/user/owner.png");
            .activation {
                margin: 10px 50px 0 0;
                width: 120px;
                height: 120px;
                background-image: url("~@/assets/imges/user/activation.png");
            }
        }
    }
    .list {
        background-color: #fff;
        padding: 0 30px;
        .van-button {
            width: 100%;
        }
        .btn {
            margin-top: 0;
            padding: 40px 0;
            color: #333333;
            .btn-ico-el {
                width: 44px;
                height: 44px;
                margin-right: 30px;
            }
        }
        .border-bottom:after {
            width: 100%;
            left: 0;
        }
    }
}
</style>
